export default __webpack_public_path__ + "static/media/arrowDown.d73abd3e.svg";